import { DO_NOT_USE_FaWrapper } from '../../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { getIcon } from './utils/getIcon.js';
import { Container, ToastHeader, IconContainer, ToastTitle, UndoButton, ToastCloseButton, ToastBody, ToastMessage, ToastDate } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Toast(props) {
  var onClose = props.onClose,
    icon = props.icon,
    _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
    title = props.title,
    lightMode = props.lightMode,
    message = props.message,
    date = props.date,
    _props$anchorOrigin = props.anchorOrigin,
    anchorOrigin = _props$anchorOrigin === void 0 ? 'bottom-center' : _props$anchorOrigin,
    undo = props.undo;
  var media = icon || getIcon(appearance, lightMode);
  return /*#__PURE__*/jsxs(Container, {
    $lightMode: lightMode,
    $anchorOrigin: anchorOrigin,
    children: [/*#__PURE__*/jsxs(ToastHeader, {
      children: [/*#__PURE__*/jsx(IconContainer, {
        children: media
      }), /*#__PURE__*/jsx(ToastTitle, {
        $fontSize: "medium",
        $fontWeight: "medium",
        $lightMode: lightMode,
        children: title
      }), undo && /*#__PURE__*/jsx(UndoButton, {
        type: "button",
        onClick: function onClick() {
          undo.action();
          onClose();
        },
        $lightMode: lightMode,
        children: undo.text
      }), /*#__PURE__*/jsx(ToastCloseButton, {
        $lightMode: lightMode,
        onClick: onClose,
        appearance: "ghost",
        $round: true,
        size: "small",
        children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
          icon: faXmark
        })
      })]
    }), (message || date) && /*#__PURE__*/jsxs(ToastBody, {
      children: [message && /*#__PURE__*/jsx(ToastMessage, {
        $fontSize: "small",
        $lightMode: lightMode,
        children: message
      }), date && /*#__PURE__*/jsx(ToastDate, {
        $fontSize: "tiny",
        $lightMode: lightMode,
        children: date
      })]
    })]
  });
}

export { Toast as default };
